import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-export-canvas',
  template: `<button class="btn btn-default" style="height: 40px;" (click)="exportToImg()">
  <i class="fa fa-download" aria-hidden="true"></i>
  </button>`
})
export class ExportCanvasComponent {
  @Input() elementRef: any;
  @Input() imgType: string;

  constructor() { }

  exportToImg() {
    if (this.elementRef) {
      var imgURL = this.elementRef.toDataURL(this.imgType || 'image/png');
      var a = document.createElement('a');
      a.download = 'chart.png';
      a.href = imgURL;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_shared/export-canvas.component.ts